// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Qdiy","empty":"ModalGraph_empty__3NhuZ"};